import React, { Component } from "react";
import PropTypes from "prop-types";
import Caption from "../Caption";
import styles from "./Image.css";

class Image extends Component {
  render() {
    const { data } = this.props.block;
    return (
      <div className={styles.root}>
        <div className={styles.container}>
          <img
            id={data.image_id}
            src={data.src}
            alt={data.alt_text}
            className={styles.image}
          />
          <Caption>{this.props.children}</Caption>
        </div>
      </div>
    );
  }
}

Image.propTypes = {
  block: PropTypes.object.isRequired,
};

export default Image;
